import httpDriver from 'app/utils/httpDriver';
import { TMutation, TQuery } from 'app/Requests/types';
import { apiRoutes, apiRoutesNotifications } from 'settings/utils/apiRoutes';
import { checkIsStoryBookPath } from 'app/utils/check-is-story-book-path';

export const getSettingsHandler = async (): Promise<any> => {
  const { data } = await httpDriver.get(apiRoutes.showSettings);
  return data?.payload?.records;
};
export const getDefaultSettingsHandler = async (): Promise<any> => {
  const { data } = await httpDriver.get(apiRoutes.showDefaultSettings);
  return data?.payload?.records;
};
export const getLandingPages = async (): Promise<any> => {
  const { data } = await httpDriver.get(apiRoutes.getLandingPages);
  return data?.payload?.records;
};

export const getTimezones = async (): Promise<any> => {
  const { data } = await httpDriver.post(apiRoutes.timezones);

  return data?.payload?.records.map((item: any) => ({
    label: item.key,
    value: item.value,
  }));
};
export const getUserSettings = async (): Promise<any> => {
  const { data } = await httpDriver.get(apiRoutes.getUserSettings);
  return data?.payload?.records;
};
export const updateUserSettings = async (body: TMutation): Promise<any> => {
  const { data } = await httpDriver.put(apiRoutes.updateUserSettings, body);
  return data?.payload?.records;
};

export const updateSettingsHandler = async (body: TMutation): Promise<any> => {
  const { data } = await httpDriver.put(apiRoutes.updateSettings, body);
  return data;
};

export const getHelpData = async ({ queryKey }: TQuery): Promise<any> => {
  const { data } = await httpDriver.post(
    `${queryKey[1]}${checkIsStoryBookPath()}${apiRoutes.helpers}`
  );
  return data?.payload?.records;
};

export const updateHelpers = async (body: TMutation): Promise<any> => {
  const { data } = await httpDriver.put(
    `${body.moduleName}${checkIsStoryBookPath()}${apiRoutes.helpersUpdate}`,
    { key: body.key, description: body.description, url: body.url }
  );
  return data;
};

///apiRoutesNotifications

export const loadAllNotificationsData = async ({
  queryKey,
}: TQuery): Promise<any> => {
  const { data } = await httpDriver.post(
    apiRoutesNotifications.allNotifications,
    queryKey[1]
  );
  return data.payload;
};

export const notificationRead = async (body: TMutation): Promise<any> => {
  const { data } = await httpDriver.post(
    apiRoutesNotifications.loadNotificationRead,
    body
  );
  return data;
};

// Release Notes

export const getReleaseNotes = async (): Promise<any> => {
  const { data } = await httpDriver.post(apiRoutes.getAllReleaseNotes);
  return data?.payload?.records;
};

export const storeReleaseNotes = async (body: TMutation): Promise<any> => {
  const { data } = await httpDriver.post(apiRoutes.storeReleaseNotes, body);
  return data;
};

export const editReleaseNotes = async (body: TMutation): Promise<any> => {
  const { data } = await httpDriver.put(apiRoutes.updateReleaseNotes, body);
  return data;
};
export const deleteReleaseNotes = async ({
  id,
  successMessage,
}: TMutation<string>): Promise<any> => {
  const { data } = await httpDriver.delete(apiRoutes.deleteReleaseNotes, {
    data: { ids: [+id] },
  });
  return { ...data, successMessage };
};

export const getModules = async (): Promise<any> => {
  const { data } = await httpDriver.post(apiRoutes.modules, {});
  return data?.payload?.records?.map((item: any) => ({
    label: item.name,
    value: item.id,
  }));
};

export const getReleaseNoteDetails = async ({
  queryKey,
}: TQuery): Promise<any> => {
  const { data } = await httpDriver.post(apiRoutes.getReleaseNote, queryKey[1]);
  return data?.payload?.records;
};
export const getReleaseNoteNotification = async (): Promise<any> => {
  const { data } = await httpDriver.post(apiRoutes.releaseNotesNotification);
  return data?.payload?.records;
};
export const setReleaseNoteNotificationMark = async (): Promise<any> => {
  const { data } = await httpDriver.post(
    apiRoutes.releaseNotesNotificationMark
  );
  return data?.payload?.records;
};
